/* global $, SGEvent, SGAction, sgData */
import AmazonPay from './AmazonPay';

/**
 * Makes AmazonPay scripts instantiated
 */
class AmazonPayFactory extends AmazonPay {
  /**
   * Constructs
   * @param {Object} opts opts
   */
  constructor(opts) {
    super(opts, $, SGEvent, SGAction, sgData);
  }
}

export default AmazonPayFactory;



// WEBPACK FOOTER //
// ./Library/1.0/app/amazon-pay/AmazonPayFactory.js